"use strict";
exports.__esModule = true;
var transaction_converter_1 = require("@iota/transaction-converter");
var _1 = require("./");
/**
 * @method createGetTransactionObjects
 *
 * @memberof module:core
 *
 * @param {Provider} provider - Network provider
 *
 * @return {Function} {@link #module_core.getTransactionObjects `getTransactionObjects`}
 */
exports.createGetTransactionObjects = function (provider) {
    var getTrytes = _1.createGetTrytes(provider);
    /**
     * Fetches the transaction objects, given an array of transaction hashes.
     *
     * @example
     *
     * ```js
     * getTransactionObjects(hashes)
     *   .then(transactions => {
     *     // ...
     *   })
     *   .catch(err => {
     *     // handle errors
     *   })
     * ```
     *
     * @method getTransactionObjects
     *
     * @memberof module:core
     *
     * @param {Hash[]} hashes - Array of transaction hashes
     * @param {Function} [callback] - Optional callback
     *
     * @returns {Promise}
     * @fulfil {Transaction[]} - List of transaction objects
     * @reject {Error}
     * - `INVALID_TRANSACTION_HASH`
     * - Fetch error
     */
    return function getTransactionObjects(hashes, callback) {
        return getTrytes(hashes)
            .then(transaction_converter_1.asTransactionObjects(hashes))
            .asCallback(callback);
    };
};
//# sourceMappingURL=createGetTransactionObjects.js.map